<template>
  <div class="carousel" v-loading="loading">
    <back />
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
      <el-row>
        <el-col>
          <el-form-item label="图片" prop="carouselUrl">
            <el-upload class="pic_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
              :show-file-list="false" :on-success="uploadSuccess('ruleForm', 'carouselUrl')"
              :before-upload="beforeUploads" :on-remove="() => onRemove('ruleForm', 'carouselUrl')"
              :disabled="ruleForm.carouselUrl ? true : false">
              <img v-if="ruleForm.carouselUrl" :src="ruleForm.carouselUrl" class="picurl" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <i v-if="ruleForm.carouselUrl" class="delpic_uploader el-icon-error"
              @click="() => onRemove('ruleForm', 'carouselUrl')"></i>
            <div style="color: #7b7d81;font-size: 12px;line-height: 1.5; display: block;margin-top: 8px;margin-left:50px">支持 JPG、JPEG、PNG 格式，建议尺寸：375px × 420px，图片大小不超过 10 MB</div>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="标题" prop="title">
            <el-input style="width: 400px;" v-model.trim="ruleForm.title" placeholder="请输入标题"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="排序" prop="sortNum">
            <el-input-number style="width: 300px;" v-model.trim="ruleForm.sortNum" :min="1"
              label="请输入排序"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="链接类型：" prop="linkType">
            <el-radio-group v-model="ruleForm.linkType" @change="handleChangeLinkType" aria-hidden>
              <el-radio label="2">直播</el-radio>
              <el-radio label="1">课程</el-radio>
              <el-radio label="3">活动</el-radio>
              <el-radio label="5">游学</el-radio>
              <el-radio label="4">图片</el-radio>
              <el-radio label="0">无链接</el-radio>
              <el-radio label="6">资讯</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <div class="s_wrapper" v-if="linkTypeStatus == 2">
            <el-input class="s_input" v-model.trim="liveName" placeholder="请输入直播间名称" suffix-icon="el-icon-search"
              @change="onSearch" clearable></el-input>
            <el-input class="s_input" v-model.trim="teacherName" placeholder="请输入专家名称" suffix-icon="el-icon-search"
              @change="onSearch" clearable></el-input>
          </div>
          <div class="s_wrapper" v-if="linkTypeStatus == 3">
            <el-input class="s_input" v-model.trim="activityName" placeholder="请输入活动名称" suffix-icon="el-icon-search"
              @change="onSearch" clearable></el-input>
            <el-select v-model="activityType" placeholder="选择活动类型" clearable @change="onSearch">
              <el-option v-for="item in activityTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="activityStatus" placeholder="选择活动状态" clearable @change="onSearch">
              <el-option v-for="item in activityStatusOptions" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="s_wrapper" v-if="linkTypeStatus == 1">
            <el-input class="s_input" v-model="courseName" placeholder="请输入课程标题" suffix-icon="el-icon-search"
              @change="onSearch" clearable></el-input>
          </div>
          <div class="s_wrapper" v-if="linkTypeStatus == 5">
            <el-input class="s_input" v-model="name" placeholder="请输入游学名称" suffix-icon="el-icon-search"
              @change="onSearch" clearable></el-input>
          </div>
          <div class="s_wrapper" v-if="linkTypeStatus == 6">
            <el-input class="s_input" v-model="zixunName" placeholder="请输入资讯标题" suffix-icon="el-icon-search"
              @change="onSearch" clearable></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="linkTypeStatus == 4">
        <el-col>
          <el-form-item label="链接图片" prop="picUrl">
            <el-upload class="pic_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
              :show-file-list="false" :on-success="uploadSuccess1('ruleForm', 'picUrl')" :before-upload="beforeUploads1"
              :on-remove="() => onRemove1('ruleForm', 'picUrl')" :disabled="ruleForm.picUrl ? true : false">
              <el-image v-if="ruleForm.picUrl" class="picurl" :src="ruleForm.picUrl"
                :preview-src-list="[ruleForm.picUrl]">
              </el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <i v-if="ruleForm.picUrl" class="delpic_uploader1 el-icon-error"
              @click="() => onRemove1('ruleForm', 'picUrl')"></i>
            <div style="color: #7b7d81;font-size: 12px;line-height: 1.5; display: block;margin-top: 8px;margin-left:75px">支持 JPG、JPEG、PNG 格式，图片大小不超过 10 MB</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="g_table" v-if="linkTypeStatus !== 4">
      <!-- 直播课程 -->
      <el-table ref="singleTable" :data="liveTableData" highlight-current-row @current-change="handleLiveMultipleChoice"
        style="width: 100%" max-height="540" v-if="linkTypeStatus == 2">
        <el-table-column min-width="35">
          <template slot-scope="scope">
            <el-radio class="radio" :label="scope.row" v-model="currentRow">{{ "" }}</el-radio>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="" label="直播间ID" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="liveName" label="直播名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="categoryName" label="直播分类" show-overflow-tooltip></el-table-column>
        <el-table-column prop="price" label="直播价格" show-overflow-tooltip></el-table-column>
        <el-table-column prop="buyerCount" label="预约人数" show-overflow-tooltip></el-table-column>
        <el-table-column prop="teacherName" label="直播主讲专家" show-overflow-tooltip></el-table-column>
        <el-table-column prop="startTime" label="直播开始时间" show-overflow-tooltip></el-table-column>
        <el-table-column prop="endTime" label="直播结束时间" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdTime" label="直播发布时间" show-overflow-tooltip></el-table-column>
        <el-table-column prop="liveStatus" label="直播状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.liveStatus == 1">未开始</div>
            <div v-if="scope.row.liveStatus == 2">直播中</div>
            <div v-if="scope.row.liveStatus == 3">已结束</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 视频课程 -->
      <el-table ref="singleTable" :data="videoTableData" highlight-current-row
        @current-change="handleLiveMultipleChoice" style="width: 100%" max-height="540" v-if="linkTypeStatus == 1">
        <el-table-column min-width="35">
          <template slot-scope="scope">
            <el-radio class="radio" :label="scope.row" v-model="currentRow">{{ "" }}</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="courseName" label="课程名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="categoryName" label="课程分类" show-overflow-tooltip></el-table-column>
        <el-table-column prop="price" label="课程价格" show-overflow-tooltip></el-table-column>
        <el-table-column prop="effectiveDay" label="购买有效期" show-overflow-tooltip></el-table-column>
        <el-table-column prop="buyerCount" label="购买人数" show-overflow-tooltip></el-table-column>
        <el-table-column prop="teacherName" label="课程专家" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdTime" label="发布时间" show-overflow-tooltip></el-table-column>
      </el-table>
      <!-- 活动课程 -->
      <el-table ref="singleTable" :data="activityTableData" highlight-current-row
        @current-change="handleLiveMultipleChoice" style="width: 100%" max-height="540" v-if="linkTypeStatus == 3">
        <el-table-column min-width="35">
          <template slot-scope="scope">
            <el-radio class="radio" :label="scope.row" v-model="currentRow">{{ "" }}</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="activityName" label="活动名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="activityType" label="活动类型" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.activityType == 0">投票活动</div>
            <div v-if="scope.row.activityType == 1">进群活动</div>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="活动分类" show-overflow-tooltip></el-table-column>
        <el-table-column prop="" label="投票次数" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.voteCount">
              <span v-if="scope.row.voteType == 0">总共</span>
              <span v-if="scope.row.voteType == 1">每天</span>
              {{ scope.row.voteCount }} 次
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column prop="singUpCount" label="已报名人数" show-overflow-tooltip></el-table-column>
        <el-table-column prop="signUpStartTime" label="报名开始时间" show-overflow-tooltip min-width="110"></el-table-column>
        <el-table-column prop="signUpEndTime" label="报名截止时间" show-overflow-tooltip min-width="110"></el-table-column>
        <el-table-column prop="voteStartTime" label="投票开始时间" show-overflow-tooltip min-width="110">
          <template slot-scope="scope">
            <div>{{ scope.row.voteStartTime || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="voteEndTime" label="投票截止时间" show-overflow-tooltip min-width="110">
          <template slot-scope="scope">
            <div>{{ scope.row.voteEndTime || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="活动状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0" style="color: red;">未开始</div>
            <div v-if="scope.row.status == 1">报名中</div>
            <div v-if="scope.row.status == 2">报名截止</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 游学课程 -->
      <el-table ref="singleTable" :data="studyTourTableData" highlight-current-row
        @current-change="handleLiveMultipleChoice" style="width: 100%" max-height="540" v-if="linkTypeStatus == 5">
        <el-table-column min-width="35">
          <template slot-scope="scope">
            <el-radio class="radio" :label="scope.row" v-model="currentRow">{{ "" }}</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="游学名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="categoryName" label="游学分类" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="" label="游学时间" show-overflow-tooltip min-width="110">
          <template slot-scope="scope">
            <div>{{ `${scope.row.startTime} ~ ${scope.row.endTime}` }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="teacherName" label="带队老师" show-overflow-tooltip min-width="110"></el-table-column>
        <el-table-column prop="signUpCount" label="报名数量" show-overflow-tooltip min-width="110"></el-table-column>
        <el-table-column prop="createdTime" label="发布时间" show-overflow-tooltip min-width="110"></el-table-column>
      </el-table>
      <!-- 资讯 -->
      <el-table ref="singleTable" :data="zixunTableData" highlight-current-row
        @current-change="handleLiveMultipleChoice" style="width: 100%" max-height="540" v-if="linkTypeStatus == 6">
        <el-table-column min-width="35">
          <template slot-scope="scope">
            <el-radio class="radio" :label="scope.row" v-model="currentRow">{{ "" }}</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="newsTitle" label="资讯标题" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdTime" label="发布时间" show-overflow-tooltip min-width="110">
          <!-- <template slot-scope="scope">
            <div>{{ `${scope.row.startTime} ~ ${scope.row.endTime}` }}</div>
          </template> -->
        </el-table-column>
        <el-table-column prop="createdUserName" label="发布人" show-overflow-tooltip min-width="110"></el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="linkTypeStatus == 1 ? videoCurrentPage : linkTypeStatus == 2 ? liveCurrentPage : linkTypeStatus == 3 ? activityCurrentPage : studyTourCurrentPage"
      :page-size="handleStudyTourPageSize()" :page-sizes="handleStudyTourPageSizeArr()"
      layout="prev, pager, next, jumper, sizes, total" :total="handleStudyTourTotalCount()"
      v-if="linkTypeStatus == 1 || linkTypeStatus == 2 || linkTypeStatus == 3 || linkTypeStatus == 5"></el-pagination>
    <div class="btn">
      <el-button type="primary" @click="submitForm('ruleForm')" :loading="btnLoading" plain>确 定</el-button>
    </div>
  </div>
</template>
<!-- handleTotal -->
<script>
export default {
  data() {
    return {
      loading: false,
      btnLoading: false,
      tableDataLoading: false,
      liveName: "", //直播名称
      activityName: "", //活动名称
      teacherName: "", //教师专家名称
      courseName: "", //课程标题
      name: "", //游学标题
      zixunName: "", //咨询标题
      activityType: "",
      activityTypeOptions: [
        {
          label: "投票活动",
          value: "0",
        },
        {
          label: "进群活动",
          value: "1",
        },
      ], // 状态options
      status: "",
      statusOptions: [
        {
          label: "未开始",
          value: "1",
        },
        {
          label: "报名中",
          value: "2",
        },
        {
          label: "报名截止",
          value: "3",
        },
      ], // 状态options
      activityStatus: "",
      activityStatusOptions: [
        {
          label: "未开始",
          value: "0",
        },
        {
          label: "报名中",
          value: "1",
        },
        {
          label: "报名截止",
          value: "2",
        },
      ], // 状态options
      liveTableData: [], //直播课程数据
      videoTableData: [], //视频课程数据
      activityTableData: [], //活动课程数据
      studyTourTableData: [], //游学课程数据
      zixunTableData: [], //咨询数据
      // 直播分页
      liveCurrentPage: 1, // 当前页码
      livePageSize: 10, // 每页显示的行数
      livePageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      liveTotalCount: 0, // 总记录数（需要从后端获取）
      // 课程分页
      videoCurrentPage: 1, // 当前页码
      videoPageSize: 10, // 每页显示的行数
      videoPageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      videoTotalCount: 0, // 总记录数（需要从后端获取）
      // 活动分页
      activityCurrentPage: 1, // 当前页码
      activityPageSize: 10, // 每页显示的行数
      activityPageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      activityTotalCount: 0, // 总记录数（需要从后端获取）
      // 游学分页
      studyTourCurrentPage: 1, // 当前页码
      studyTourPageSize: 10, // 每页显示的行数
      studyTourPageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      studyTourTotalCount: 0, // 总记录数（需要从后端获取）
      // 咨询分页
      zixunCurrentPage: 1, // 当前页码
      zixunPageSize: 10, // 每页显示的行数
      zixunPageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      zixunTotalCount: 0, // 总记录数（需要从后端获取）

      ruleForm: {
        id: null, //
        title: "", //标题
        sortNum: "", //排序
        carouselUrl: "", //内容链接
        picUrl: "", //图片链接
        linkType: "", //链接类型
        linkId: "", //课程id
        linkName: "", //课程名称
      },
      rules: {
        title: [{ required: true, message: "请输入标题内容", trigger: "blur" }],
        sortNum: [
          { required: true, message: "请输入排序内容", trigger: "blur" },
        ],
        carouselUrl: [
          { required: true, message: "请上传图片", trigger: "change" },
        ],
        picUrl: [
          { required: true, message: "请上传链接图片", trigger: "change" },
        ],
        linkType: [
          { required: true, message: "请选择链接类型", trigger: "change" },
        ],
      },
      sortNum: "", // 修改时的排序
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      currentRow: null, //单选数据
      linkTypeStatus: "", //链接类型显示状态
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.id) {
      to.meta.title = "修改轮播图";
    } else {
      to.meta.title = "新增轮播图";
    }
    next();
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  watch: {
    $route(to, from) {
      document.title = to.meta.title;
    },
  },
  created() {
    if (this.$route.query.id) this.getRequestList();
    this.getRequestSelectLiveInfoPage(); //直播
    this.getRequestSelectVideoInfoPage(); //课程
    this.getRequestActivityList(); //活动
    this.getRequestStudyTourList(); //游学
    this.getRequestZixunList(); //咨询
  },
  methods: {
    getRequestList() {
      this.loading = true;
      this.$axios
        .get(this.$api.carouselPictureInfo, {
          params: {
            id: this.$route.query.id,
          },
        })
        .then((res) => {
          if (res.code == 100) {
            this.loading = false;
            this.ruleForm = res.result;
            let { linkType, linkId } = this.ruleForm;
            if (linkType == 1) {
              this.linkTypeStatus = 1;
              linkId = res.result.linkId;
            } else if (linkType == 2) {
              this.linkTypeStatus = 2;
              linkId = res.result.linkId;
            } else if (linkType == 3) {
              this.linkTypeStatus = 3;
              linkId = res.result.linkId;
            } else if (linkType == 4) {
              this.linkTypeStatus = 4;
              linkId = res.result.linkId;
            } else if (linkType == 5) {
              this.linkTypeStatus = 5;
              linkId = res.result.linkId;
            } else if (linkType == 6) {
              this.linkTypeStatus = 6;
              linkId = res.result.linkId;
            } else {
              this.linkTypeStatus = "";
            }
          }
        })
        .catch((err) => {
          this.$message.error(err.desc);
          this.loading = false;
        });
    },
    // 直播课程列表
    getRequestSelectLiveInfoPage() {
      this.loading = true;
      this.$axios
        .get(this.$api.carouselPictureSelectLiveInfoPage, {
          params: {
            liveName: this.liveName || null,
            teacherName: this.teacherName || null,
            page: this.liveCurrentPage,
            pageSize: this.livePageSize,
          },
        })
        .then((res) => {
          this.liveTableData = res.result.list;
          this.liveTotalCount = res.result.totalCount;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err.desc);
          this.loading = false;
        });
    },
    // 课程列表请求
    getRequestSelectVideoInfoPage() {
      this.loading = true;
      this.$axios
        .post(this.$api.carouselPictureSelectVideoInfoPage, {
          categoryIdList: null,
          courseName: this.courseName || null,
          page: this.videoCurrentPage,
          pageSize: this.videoPageSize,
        })
        .then((res) => {
          this.videoTableData = res.result.list;
          this.videoTotalCount = res.result.totalCount;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err.desc);
          this.loading = false;
        });
    },
    // 活动列表请求
    getRequestActivityList() {
      this.loading = true;
      this.$axios
        .post(this.$api.activityList, {
          activityName: this.activityName || null,
          activityType: this.activityType || null,
          status: this.activityStatus || null, //活动状态：0未开始；1报名中；2报名截止；
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then((res) => {
          if (res.code == 100) {
            this.activityTableData = res.result.list;
            this.activityTotalCount = res.result.totalCount;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.desc);
          this.loading = false;
        });
    },
    // 游学列表请求
    getRequestStudyTourList() {
      this.loading = true;
      this.$axios
        .post(this.$api.carouselPictureSelectStudyTourInfoPage, {
          name: this.name || null,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then((res) => {
          if (res.code == 100) {
            this.studyTourTableData = res.result.list;
            this.studyTourTotalCount = res.result.totalCount;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.desc);
          this.loading = false;
        });
    },
    // 咨询列表请求
    getRequestZixunList() {
      this.loading = true;
      this.$axios
        .get(this.$api.newsInfoSelectPage, {
          params: {
            newsTitle: this.zixunName || null,
            page: this.zixunCurrentPage,
            pageSize: this.zixunPageSize,
            status: 1,
          },
        })
        .then((res) => {
          if (res.code == 100) {
            this.zixunTableData = res.result.list;
            this.zixunTotalCount = res.result.totalCount;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.desc);
          this.loading = false;
        });
    },
    // 文件上传前
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt5M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
      // return isJPG
    },
    // 删除图片
    onRemove(form, str) {
      this.$set(this[form], str, "");
    },
    // 上传成功
    uploadSuccess(form, str) {
      return (response) => {
        if (response.code == 100) {
          this.$set(this[form], str, response.result.fileUrl);
        } else {
          this.$message.error(response.desc);
        }
      };
    },
    // 文件上传前
    beforeUploads1(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt5M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    // 删除图片
    onRemove1(form, str) {
      this.$set(this[form], str, "");
    },
    // 上传成功
    uploadSuccess1(form, str) {
      return (response) => {
        if (response.code == 100) {
          this.$set(this[form], str, response.result.fileUrl);
        } else {
          this.$message.error(response.desc);
        }
      };
    },
    // 取消当前选中
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    // 当前选中的数据
    handleLiveMultipleChoice(row) {
      this.currentRow = row;
      console.log(this.currentRow);

      this.$set(this.ruleForm, "linkId", this.currentRow?.id);
      this.$set(
        this.ruleForm,
        "linkName",
        this.currentRow?.courseName ||
          this.currentRow?.liveName ||
          this.currentRow?.activityName ||
          this.currentRow?.name ||
          this.currentRow?.newsTitle
      );
    },
    // 选择链接类型
    handleChangeLinkType(value) {
      // console.log('选择链接类型', value);
      this.$set(this.ruleForm, "linkId", 0);
      this.currentRow = null;
      if (value == 0) {
        this.linkTypeStatus = "";
        this.$set(this.ruleForm, "linkName", "");
      } else {
        this.linkTypeStatus = value;
        this.$set(this.ruleForm, "linkId", this.linkTypeStatus == 4 ? 0 : "");
        this.$set(this.ruleForm, "picUrl", "");
        this.$set(this.ruleForm, "linkName", "");
      }
    },
    // 提交数据
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          const courseInfo =
            this.currentRow == null &&
            this.linkTypeStatus !== "" &&
            this.linkTypeStatus != 4 &&
            (!this.$route.query.id || this.ruleForm.linkId == 0);
          if (courseInfo) {
            if (this.linkTypeStatus == 1)
              this.$message.error("请先选择一条课程数据以继续操作");
            if (this.linkTypeStatus == 2)
              this.$message.error("请先选择一条直播数据以继续操作");
            if (this.linkTypeStatus == 3)
              this.$message.error("请先选择一条活动数据以继续操作");
            if (this.linkTypeStatus == 5)
              this.$message.error("请先选择一条游学数据以继续操作");
            if (this.linkTypeStatus == 6)
              this.$message.error("请先选择一条咨询数据以继续操作");
            return;
          }
          this.btnLoading = true;
          let api;
          let obj = Object.assign({}, this.ruleForm);
          if (this.$route.query.id) {
            api = this.$api.carouselPictureEdit;
          } else {
            api = this.$api.carouselPictureAdd;
          }
          this.$axios
            .post(api, obj)
            .then((res) => {
              if (res.code == 100) {
                this.btnLoading = false;
                this.$message.success(
                  `${this.$route.query.id ? "修改" : "新增"}成功`
                );
                this.$router.go(-1);
              }
            })
            .catch((err) => {
              this.btnLoading = false;
              this.$message.error(err.desc);
            });
        }
      });
    },
    // 搜索
    onSearch() {
      if (this.linkTypeStatus == 1) {
        this.videoTableData = [];
        this.videoCurrentPage = 1;
        this.getRequestSelectVideoInfoPage(); //课程
      } else if (this.linkTypeStatus == 3) {
        this.activityTableData = [];
        this.activityCurrentPage = 1;
        this.getRequestActivityList(); //活动
      } else if (this.linkTypeStatus == 5) {
        this.studyTourTableData = [];
        this.studyTourCurrentPage = 1;
        this.getRequestStudyTourList(); //游学
      } else if (this.linkTypeStatus == 6) {
        this.zixunTableData = [];
        this.zixunCurrentPage = 1;
        this.getRequestZixunList(); //咨询
      } else {
        this.liveTableData = [];
        this.liveCurrentPage = 1;
        this.getRequestSelectLiveInfoPage(); //直播
      }
    },
    // 分页器总条数展示处理
    handleStudyTourTotalCount() {
      switch (Number(this.linkTypeStatus)) {
        case 1:
          return this.videoTotalCount;
        case 2:
          return this.liveTotalCount;
        case 3:
          return this.activityTotalCount;
        case 5:
          return this.studyTourTotalCount;
        case 6:
          return this.zixunTotalCount;
      }
    },
    // 分页器每页显示的行数展示处理
    handleStudyTourPageSize() {
      switch (Number(this.linkTypeStatus)) {
        case 1:
          return this.videoPageSize;
        case 2:
          return this.livePageSize;
        case 3:
          return this.activityPageSize;
        case 5:
          return this.studyTourPageSize;
        case 6:
          return this.zixunPageSize;
      }
    },
    // 分页器显示的行数展示处理
    handleStudyTourPageSizeArr() {
      switch (Number(this.linkTypeStatus)) {
        case 1:
          return this.videoPageSizeArr;
        case 2:
          return this.livePageSizeArr;
        case 3:
          return this.activityPageSizeArr;
        case 5:
          return this.studyTourPageSizeArr;
        case 6:
          return this.zixunPageSizeArr;
      }
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      // this.tableData = []
      // this.pageSize = e
      if (this.linkTypeStatus == 1) {
        this.videoTableData = [];
        this.videoPageSize = e;
        this.getRequestSelectVideoInfoPage(); //课程
      } else if (this.linkTypeStatus == 3) {
        this.activityPageSize = e;
        this.activityTableData = [];
        this.getRequestActivityList(); //活动
      } else if (this.linkTypeStatus == 5) {
        this.studyTourPageSize = e;
        this.studyTourTableData = [];
        this.getRequestStudyTourList(); //游学
      } else if (this.linkTypeStatus == 6) {
        this.zixunTableData = [];
        this.zixunCurrentPage = 1;
        this.getRequestZixunList(); //咨询
      } else {
        this.liveTableData = [];
        this.livePageSize = e;
        this.getRequestSelectLiveInfoPage(); //直播
      }
    },
    // 换页
    handleCurrentChange(e) {
      // this.tableData = []
      // this.currentPage = e
      if (this.linkTypeStatus == 1) {
        this.videoTableData = [];
        this.videoCurrentPage = e;
        this.getRequestSelectVideoInfoPage(); //课程
      } else if (this.linkTypeStatus == 3) {
        this.activityTableData = [];
        this.activityCurrentPage = e;
        this.getRequestActivityList(); //活动
      } else if (this.linkTypeStatus == 5) {
        this.studyTourTableData = [];
        this.studyTourCurrentPage = e;
        this.getRequestStudyTourList(); //游学
      } else if (this.linkTypeStatus == 6) {
        this.zixunTableData = [];
        this.zixunCurrentPage = 1;
        this.getRequestZixunList(); //咨询
      } else {
        this.liveTableData = [];
        this.liveCurrentPage = e;
        this.getRequestSelectLiveInfoPage(); //直播
      }
    },
  },
};
</script>

<style scoped lang="scss">
.carousel {
  ::v-deep .el-radio__original {
    display: none !important;
  }

  ::v-deep .el-input-number__decrease {
    border-radius: 10px 0 0 10px;
  }

  ::v-deep .el-input-number__increase {
    border-radius: 0 10px 10px 0;
  }

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

  .show_img {
    color: $themes;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .pic_uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    ::v-deep .el-upload:hover {
      border-color: $themes;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: $themes;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }

    ::v-deep .el-upload--picture-card {
      background-color: #fff;
    }

    ::v-deep .el-upload-list__item-thumbnail {
      object-fit: cover;
    }

    .picurl {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: cover;
    }
  }

  .delpic_uploader {
    position: absolute;
    top: -10px;
    left: 140px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }

  .delpic_uploader1 {
    position: absolute;
    top: -10px;
    left: 170px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
